/* Custom search UI (A/B variant B).
   Drives the mobile overlay, the desktop dropdown and predictive results.
   Active only while <html> carries the .custom-search-active class. */
(function () {
  if (!customElements.get('custom-search')) {
    customElements.define(
      'custom-search',
      class CustomSearch extends HTMLElement {
        constructor() {
          super();
          this.overlay = this.querySelector('[data-search-overlay]');
          this.dropdown = this.querySelector('[data-search-dropdown]');
          this.backdrop = this.querySelector('[data-search-backdrop]');
          this.inputs = Array.from(this.querySelectorAll('[data-search-input]'));
          this.debounceTimer = null;
          this.lastTerm = '';

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          this.suggestUrl = root.replace(/\/$/, '') + '/search/suggest';

          this.bindEvents();
        }

        get isActive() {
          return document.documentElement.classList.contains('custom-search-active');
        }

        bindEvents() {
          // Mobile: open overlay (focus must run inside the user gesture for iOS)
          this.querySelectorAll('[data-search-open]').forEach((btn) => {
            btn.addEventListener('click', () => this.openOverlay());
          });

          // Close buttons (overlay back + dropdown X)
          this.querySelectorAll('[data-search-close]').forEach((btn) => {
            btn.addEventListener('click', () => this.closeAll());
          });

          if (this.backdrop) this.backdrop.addEventListener('click', () => this.closeAll());

          // Inputs: debounced predictive search
          this.inputs.forEach((input) => {
            input.addEventListener('input', () => this.onInput(input));
          });

          // Clear buttons
          this.querySelectorAll('[data-search-clear]').forEach((btn) => {
            btn.addEventListener('click', () => {
              const surface = btn.closest('[data-search-overlay], [data-search-dropdown]');
              const input = surface && surface.querySelector('[data-search-input]');
              if (input) {
                input.value = '';
                input.focus();
                this.onInput(input);
              }
            });
          });

          // Tab switching (delegated, both surfaces)
          this.addEventListener('click', (e) => {
            const tab = e.target.closest('.custom-search-results__tab');
            if (tab) this.switchTab(tab);
          });

          // Escape closes whichever surface is open
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeAll();
          });

          // Desktop: the header search icon toggles the dropdown instead of the
          // theme's default modal. Intercept in the capture phase.
          document.addEventListener(
            'click',
            (e) => {
              if (!this.isActive) return;
              if (window.innerWidth < 990) return;
              const summary = e.target.closest('.header__search summary');
              if (!summary) return;
              e.preventDefault();
              e.stopImmediatePropagation();
              // Make sure the theme's <details> stays closed
              const details = summary.closest('details');
              if (details) details.removeAttribute('open');
              this.toggleDropdown();
            },
            true
          );
        }

        openOverlay() {
          if (!this.overlay) return;
          this.overlay.classList.add('is-open');
          document.documentElement.classList.add('custom-search-overlay-open');
          const input = this.overlay.querySelector('[data-search-input]');
          if (input) input.focus();
        }

        toggleDropdown() {
          if (!this.dropdown) return;
          if (this.dropdown.classList.contains('is-open')) {
            this.closeAll();
          } else {
            this.dropdown.classList.add('is-open');
            document.documentElement.classList.add('custom-search-dropdown-open');
            const input = this.dropdown.querySelector('[data-search-input]');
            if (input) input.focus();
          }
        }

        closeAll() {
          if (this.overlay) this.overlay.classList.remove('is-open');
          if (this.dropdown) this.dropdown.classList.remove('is-open');
          document.documentElement.classList.remove('custom-search-overlay-open');
          document.documentElement.classList.remove('custom-search-dropdown-open');
        }

        onInput(input) {
          const surface = input.closest('[data-search-overlay], [data-search-dropdown]');
          if (!surface) return;
          const term = input.value.trim();
          const clearBtn = surface.querySelector('[data-search-clear]');
          if (clearBtn) clearBtn.classList.toggle('is-hidden', term.length === 0);

          const discovery = surface.querySelector('[data-discovery]');
          const container = surface.querySelector('[data-results-container]');

          if (term.length === 0) {
            if (discovery) discovery.style.display = '';
            if (container) container.innerHTML = '';
            return;
          }

          if (discovery) discovery.style.display = 'none';
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => this.fetchResults(term, container), 300);
        }

        fetchResults(term, container) {
          if (!container) return;
          container.classList.add('is-loading');
          const params = new URLSearchParams({
            q: term,
            'resources[type]': 'product,collection,article,query',
            'resources[limit]': '8',
            section_id: 'custom-predictive-search',
          });
          fetch(`${this.suggestUrl}?${params.toString()}`)
            .then((res) => res.text())
            .then((text) => {
              const tmp = document.createElement('div');
              tmp.innerHTML = text;
              const results = tmp.querySelector('.custom-search-results');
              container.innerHTML = results ? results.outerHTML : text;
              container.classList.remove('is-loading');
            })
            .catch(() => {
              container.classList.remove('is-loading');
            });
        }

        switchTab(tab) {
          const results = tab.closest('.custom-search-results');
          if (!results) return;
          const target = tab.dataset.tab;
          results.querySelectorAll('.custom-search-results__tab').forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          results.querySelectorAll('.custom-search-results__panel').forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.panel === target);
          });
        }
      }
    );
  }
})();